export enum PartnerFeatures {
  Chat = "chat",
  // BSCPF-6078. Named for screening to keep it clear of the CRM analytics
  // `owner_reports` entitlement, which is a different feature entirely.
  OwnerReports = "owner_screening_reports",
  SelfServeIncomeReverify = "wip_feat_income_self_serve_reverify",
  InscribeW2Verification = "inscribe_w2_verification"
}

export enum PropertyManagementSystem {
  Appfolio = "appfolio",
  Buildium = "buildium",
  Entrata = "entrata",
  ManageAmerica = "manage_america",
  Quext = "quext",
  RentManager = "rent_manager",
  RentersWarehouse = "renters_warehouse",
  Rentvine = "rentvine",
  Resman = "resman",
  Yardi = "yardi",
  Propertyware = "propertyware",
  Revela = "revela",
  Other = "other"
}

export interface Partner {
  slug: string;
  name: string;
  email: string;
  id: number;
  partner_features?: PartnerFeatures[];
  property_management_system?: PropertyManagementSystem;
  hubspot_hub_id?: string;
}
